import actionCreatorFactory from 'typescript-fsa'

const actionCreator = actionCreatorFactory()

export const UIStateActions = {
  setEnableMobileMenu: actionCreator<boolean>('SET_ENABLE_MOBILE_MENU'),
  setEnableMobileMenuSmall: actionCreator<boolean>('SET_ENABLE_MOBILE_MENU_SMALL'),
  setEnableClosedSidebar: actionCreator<boolean>('SET_ENABLE_CLOSED_SIDEBAR'),
}
